import { render } from "./TzInputError.vue?vue&type=template&id=39ea4448&scoped=true&ts=true"
import script from "./TzInputError.vue?vue&type=script&lang=ts"
export * from "./TzInputError.vue?vue&type=script&lang=ts"

import "./TzInputError.vue?vue&type=style&index=0&id=39ea4448&scoped=true&lang=css"

import exportComponent from "/Users/pablo/Sites/buen-provecho-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ea4448"]])

export default __exports__